import { useErrorService } from "@scayla/core";
import type { Component } from "vue";

import type { IconName } from "./iconNames.generated";
import { iconRegistry } from "./iconRegistry";

export const UNKNOWN_ICON: IconName = "phosphor/question";

const warnedNames = new Set<string>();

/**
 * An unknown name gets `UNKNOWN_ICON` and one warning per name; an empty name gets nothing, so a
 * missing icon leaves no mark.
 */
export const resolveIcon = (name: string | undefined): Component | undefined => {
  if (!name) return undefined;

  const component = iconRegistry.get(name);
  if (component) return component;

  if (!warnedNames.has(name)) {
    warnedNames.add(name);
    useErrorService().logger.warn(`Unknown icon "${name}"`)();
  }
  return iconRegistry.get(UNKNOWN_ICON);
};
